import type { RouteLocationNormalized } from 'vue-router'

function requiresAuth(route: RouteLocationNormalized): boolean {
  return route.matched.length > 0 && !route.meta.public
}

function pageTitle(route: RouteLocationNormalized): string {
  return route.meta.title ? `${route.meta.title} - Plentify` : 'Plentify'
}

function applyBackgroundTheme(
  from: RouteLocationNormalized,
  to: RouteLocationNormalized
) {
  if (from.meta.backgroundTheme) {
    document.body.classList.remove(from.meta.backgroundTheme.toString())
  }
  if (to.meta.backgroundTheme) {
    document.body.classList.add(to.meta.backgroundTheme.toString())
  }
}

export { requiresAuth, pageTitle, applyBackgroundTheme }
